// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__vRWop","inputWrap":"Table_inputWrap__3Qu8_","col":"Table_col__1N7IA","bmiTooltip":"Table_bmiTooltip__VnYSi"};